import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import MainLayout from './components/Layout/MainLayout';
import Dashboard from './pages/Dashboard/Dashboard';
import SalesChannels from './pages/SalesChannels/SalesChannels';
import EcommerceWizard from './pages/SalesChannels/EcommerceWizard';
import ChatGPTWizard from './pages/SalesChannels/ChatGPTWizard';
import GeminiWizard from './pages/SalesChannels/GeminiWizard';
import PerplexityWizard from './pages/SalesChannels/PerplexityWizard';
import MCPWizard from './pages/SalesChannels/MCPWizard';
import ShoppingAgentWizard from './pages/SalesChannels/ShoppingAgentWizard';
import Products from './pages/Products/Products';
import Campaigns from './pages/Campaigns/Campaigns';

function App() {
  return (
    <AppProvider>
      <Router>
        <MainLayout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/sales-channels" element={<SalesChannels />} />
            <Route path="/sales-channels/ecommerce" element={<EcommerceWizard />} />
            <Route path="/sales-channels/chatgpt" element={<ChatGPTWizard />} />
            <Route path="/sales-channels/gemini" element={<GeminiWizard />} />
            <Route path="/sales-channels/perplexity" element={<PerplexityWizard />} />
            <Route path="/sales-channels/mcp" element={<MCPWizard />} />
            <Route path="/sales-channels/shopping-agent" element={<ShoppingAgentWizard />} />
            <Route path="/products" element={<Products />} />
            <Route path="/campaigns" element={<Campaigns />} />
          </Routes>
        </MainLayout>
      </Router>
    </AppProvider>
  );
}

export default App;
